import { AdminAuthCallbackPage } from "@/features/auth/pages/AdminAuthCallback";

const AdminAuthCallback = () => {
  return <AdminAuthCallbackPage />;
};

export default AdminAuthCallback;
